// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__JYrb6","title":"style_title__iJnnD","list":"style_list__YNI4l","selectedItem":"style_selectedItem__w-on7"};